export const ITEM_PROPS = [
  { value: "", label: "Nenhum" },
  { value: "RECEIVED", label: "Recebidos" },
  { value: "SENT", label: "Enviados" },
  { value: "NOT_RECEIVED", label: "Atrasados" },
];
